import { Account } from './account';
import { ModelInterface } from './model.interface';
import { PhoneNumber } from './phone-number';

export class Customer implements ModelInterface {
    id: number;
    firstname: string;
    lastname: string;
    email: string;
    account: Account;
    account_id: number;
    phone_number: PhoneNumber;
    created_at: string;
    updated_at: string;
    deleted_at: string;

    /**
     * Class constructor
     * @param  {any = null} data
     */
    constructor(data: any = null) {
        if (data) {
            this.build(data);
        }
    }

    get full_name() {
        return `${this.firstname} ${this.lastname}`;
    }

    get full_name_with_email() {
        return `${this.firstname} ${this.lastname} (${this.email})`;
    }

    /**
     * Build the object attributes
     * @param {any} attrs
     */
    build(attrs: any): void {
        this.id = attrs.id;
        this.firstname = attrs.firstname;
        this.lastname = attrs.lastname;
        this.email = attrs.email;
        this.account_id = attrs.account_id;
        this.created_at = attrs.created_at;
        this.updated_at = attrs.updated_at;
        this.deleted_at = attrs.deleted_at;

        if (attrs.account) {
            this.account = new Account(attrs.account);
        }

        if (attrs.phone_number) {
            this.phone_number = new PhoneNumber(attrs.phone_number);
        }
    }

    isDeleted() {
        return !!this.deleted_at;
    }

    /**
     * Return a JSON object representation of the object
     * @return {any}
     */
    toJson(): any {
        return {
            id: this.id,
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email,
            phone_number: this.phone_number ?
                this.phone_number.toJson() : undefined
        };
    }
}
